<template>
    <el-dialog
        class="detail"
        :visible.sync="detailVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="成员详情"
        v-loading="loading"
    >
        <el-tabs tab-position="left" v-model="tab">
            <el-tab-pane label="基本信息" name="1">
                <div class="container">
                    <div class="headCont">
                        <div style="width: 72px; margin: 10px" v-if="msg.status===1 && (msg.avatar!=='' || 'https://uc-api.loratech.cn/dingtalk/2/user/'+encodeURIComponent(msg.name)+'/avatar/100')">
                            <el-avatar
                                :src="msg.avatar || 'https://uc-api.loratech.cn/dingtalk/2/user/'+encodeURIComponent(msg.name)+'/avatar/100'"
                                :size="68"
                            ></el-avatar>

                        </div>
                      <div style="width: 72px; margin: 10px" v-else>
                        <el-avatar
                            :src="require('@/assets/image/portrait.svg')"
                            :size="68"
                        ></el-avatar>

                      </div>
                        <div class="msgCont">
                            <div class="itemCont">
                                <!-- <el-row>
                  <el-col :span="12">
                    <div class="nameCont">{{msg.name}}</div>
                    <el-tag type="info"
                            size="mini">{{msg.job}}</el-tag>
                    <el-tag size="mini">{{msg.jobStyle}}</el-tag>
                  </el-col>
                  <el-col :span="12">
                    <el-avatar src="http://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
                               :size="22"
                               :shape="circle"></el-avatar>
                    <div class="engName">{{msg.engName}}</div>
                  </el-col>
                </el-row> -->
                                <div class="leftCont">
                                    <div class="nameCont">{{ msg.name }}</div>
                                    <el-tag
                                        size="mini"
                                        style="margin-left: 14px"
                                        :type="
                                            msg.resign_date == null
                                                ? ''
                                                : 'danger'
                                        "
                                    >
                                        {{
                                            msg.resign_date == null
                                                ? "在职"
                                                : "离职"
                                        }}
                                    </el-tag>
                                    <el-tag
                                        size="mini"
                                        type="info"
                                        style="margin-left: 14px"
                                        v-if="msg.role_name"
                                    >
                                        {{ msg.role_name }}
                                    </el-tag>
                                </div>
                                <div class="rightCont">
                                    <el-avatar
                                        src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
                                        :size="26"
                                        :shape="circle"
                                        v-if="msg.parent_name"
                                    ></el-avatar>
                                    <div
                                        class="engName"
                                        style="margin-left: 14px"
                                    >
                                        {{ msg.parent_name }}
                                    </div>
                                </div>
                            </div>
                            <div class="itemCont">
                                <div class="leftCont">
                                    {{ msg.phone }}
                                </div>
                                <div class="rightCont">
                                    {{ msg.parent_name ? "上司" : "" }}
                                </div>
                            </div>
                            <div class="itemCont">
                                <div class="leftCont">
                                    {{ msg.email }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="formCont">
                        <el-row :guiter="20">
                            <el-col :span="8">
                                <div class="label">英文名：</div>
                                <div class="content">{{ msg.name_en }}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="label">性别：</div>
                                <div class="content">{{ msg.sex_cn }}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="label">出生日期：</div>
                                <div class="content">{{ msg.birthday }}</div>
                            </el-col>
                            <!-- </el-row>
            <el-row :guiter="20"> -->
                            <el-col :span="8">
                                <div class="label">籍贯：</div>
                                <div class="content">{{ msg.hometown }}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="label">学历：</div>
                                <div class="content">{{ msg.education }}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="label">专业：</div>
                                <div class="content">{{ msg.speciality }}</div>
                            </el-col>
                            <!-- </el-row>
            <el-row :guiter="20"> -->
                            <el-col :span="8">
                                <div class="label">身份证：</div>
                                <div class="content">{{ msg.identity }}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="label">紧急联系人：</div>
                                <div class="content">
                                    {{ msg.urgent_person }}
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="label">紧急联系电话：</div>
                                <div class="content">
                                    {{ msg.urgent_phone }}
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <div class="label">转正时间：</div>
                                <div class="content">{{ msg.effect_date }}</div>
                            </el-col>
                            <!-- </el-row>
            <el-row :guiter="20"> -->
                            <el-col :span="8">
                                <div class="label">入职时间：</div>
                                <div class="content">{{ msg.entry_date }}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="label">离职时间：</div>
                                <div class="content">{{ msg.resign_date }}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="label">工龄：</div>
                                <div class="content">{{ msg.work_age }}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="label">部门：</div>
                                <div class="content">{{ msg.depart_name }}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="label">工号：</div>
                                <div class="content">{{ msg.job_no }}</div>
                            </el-col>
                            <el-col :span="8">
                                <div class="label">是否已婚：</div>
                                <div class="content">
                                    {{ msg.marriage == 0 ? "未婚" : "已婚" }}
                                </div>
                            </el-col>
                            <!-- </el-row>
            <el-row :guiter="20"> -->
                            <el-col :span="24">
                                <div class="label">联系地址：</div>
                                <div class="content">{{ msg.address }}</div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="textCont">
                        <el-row :guiter="20">
                            <el-col :span="24">
                                <div class="label">个人信息：</div>
                                <div class="content">{{ msg.description }}</div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane label="教育背景" name="2">
                <div class="container">
                    <el-table
                        :data="schoolData"
                        :header-cell-style="tableHeaderColor"
                        height="200"
                    >
                        <el-table-column
                            label="学校"
                            property="school"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            label="时间"
                            property="start_date"
                            align="center"
                        >
                            <template slot-scope="scope">
                                {{ scope.row.start_date }} -
                                {{ scope.row.end_date }}
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="年限"
                            property="years"
                            align="center"
                        ></el-table-column>
                        <el-table-column
                            label="专业"
                            property="speciality"
                            align="center"
                        ></el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="健康状况" name="3">
                <div class="container">
                    <el-table
                        :data="healthData"
                        v-loading="loading"
                        :header-cell-style="tableHeaderColor"
                        height="200"
                    >
                        <el-table-column
                            label="年份"
                            property="year"
                            align="center"
                        ></el-table-column>
                        <el-table-column label="状况" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.status == 1 ? "正常" : "不健康" }}
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-tab-pane>
            <el-tab-pane label="银行卡信息" name="4">
                <div class="container">
                    <div class="formCont">
                        <el-row :guiter="20">
                            <el-col :span="12">
                                <div class="label">开户银行：</div>
                                <div class="content">
                                    {{ msg.bank_name || "暂无信息" }}
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="label">银行账号：</div>
                                <div class="content">
                                    {{ msg.bank_account || "暂无信息" }}
                                </div>
                            </el-col>
                        </el-row>
                        <el-row :guiter="20">
                            <el-col :span="12">
                                <div class="label">社保卡号：</div>
                                <div class="content">
                                    {{ msg.social_card || "暂无信息" }}
                                </div>
                            </el-col>
                            <el-col :span="12">
                                <div class="label">公积金号码：</div>
                                <div class="content">
                                    {{ msg.fund_card || "暂无信息" }}
                                </div>
                            </el-col>
                        </el-row>
                        <el-row :guiter="20">
                            <el-col :span="12">
                                <div class="label">身份证号：</div>
                                <div class="content">
                                    {{ msg.id || "暂无信息" }}
                                </div>
                            </el-col>
                        </el-row>
                        <el-row :guiter="20">
                            <el-col :span="24" style="height:200px">
                                <div class="label">身份证正反面：</div>
                                <div class="content" style="height:200px" v-if="msg.id_card_file_f&&msg.id_card_file_f.length>0&&msg.id_card_file_z&&msg.id_card_file_z.length>0">
                                  <el-row :guiter="20">
                                    <el-col :span="12" style="height:200px">
                                      <el-image :src="item" v-for="(item,i) of msg.id_card_file_f" :key="i" :preview-src-list="msg.id_card_file_f"></el-image>
                                    </el-col>
                                    <el-col :span="12" style="height:200px">
                                      <el-image :src="item" v-for="(item,i) of msg.id_card_file_z" :key="i" :preview-src-list="msg.id_card_file_z"></el-image>
                                    </el-col>
                                  </el-row>
                                </div>
                                <div class="content" v-else>
                                  暂无信息
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>

        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                @click="detailVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
export default {
    data() {
        return {
            tab: "1",
            msg: {},
            schoolData: "",
            healthData: "",
            loading: false,
        };
    },
    methods: {
        closeDialog() {
            this.$emit("update:detailVisible", this.detailVisible);
        },
        // 修改table header的背景色
        tableHeaderColor({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return "background-color: #fff !important;color: #000;font-weight: 500;";
            }
        },
        userGet() {
            oaApi.user({}, "get", this.tableItem.id).then((res) => {
                if (res) {
                    this.msg = res.data;
                }
            });
        },
        school() {
            oaApi.school({ user_id: this.tableItem.id }, "get").then((res) => {
                if (res) {
                    this.schoolData = res.data;
                }
            });
        },
        health() {
            oaApi.health({ user_id: this.tableItem.id }, "get").then((res) => {
                if (res) {
                    this.healthData = res.data;
                }
            });
        },
    },
    watch: {
        mixed: {
            handler(newValue) {
                if (newValue.detailVisible) {
                    this.tableItem = newValue.tableItem;
                    this.userGet();
                    this.school();
                    this.health();
                }
            },
            deep: true,
            immediate: false,
        },
    },
    props: {
        detailVisible: Boolean,
        tableItem: Object,
    },
    computed: {
        mixed() {
            const { detailVisible, tableItem } = this;
            return {
                detailVisible,
                tableItem,
            };
        },
    },
};
</script>
<style lang="scss">
.detail {
    width: 100%;
    .container {
        .formCont {
            border-bottom: 1px #e8e8e8 solid;
        }
    }
}
</style>